<template>
	<div class="list-container column">
		<div class="title-container">
			<div class="title">{{ $t('protectionslist.title') }}</div>
			<div class="dash-select" :class="{ mobile: isMobile }">
				<v-select
					class="panel-select dashboard"
					:value="selectedInfo"
					:options="infos"
					:placeholder="$t('protectionslist.select_floor')"
					:allowEmpty="false"
					:internalSearch="true"
					:showLabels="false"
					:custom-label="selectLabel"
					@input="selectInfo"
					label="floorName"
					track-by="id"
				>
					<span slot="noResult">{{ $t('protectionslist.no_results') }}</span>
					<span
						slot="caret"
						slot-scope="{ toggle }"
						class="caret"
						@mousedown.prevent.stop="toggle()"
					><i class="fas fa-caret-down caret-inner"></i
					></span>
				</v-select>
			</div>
		</div>
		<div class="panel-list-header" :class="{ mobile: isMobile }">
			<div class="panel-filler-icon" />
			<div class="panel-header-item pos" :class="{ mobile: isMobile }">
				{{ isMobile ? $t('protectionslist.pos') : $t('protectionslist.position_number') }}
			</div>
			<div class="panel-header-item" v-if="!isMobile">{{ $t('protectionslist.type') }}</div>
			<div class="panel-header-item placement">{{ $t('protectionslist.placement') }}</div>
			<div class="panel-header-item flaw-item" v-if="!isMobile">{{ $t('protectionslist.flaw') }}</div>
			<div class="panel-filler-special" :class="{ mobile: isMobile }" />
		</div>
		<div
			class="panel-list no-hover"
			v-for="(fireProtection, index) in items"
			:key="fireProtection.id"
			:class="[{ mobile: isMobile }, isDone(fireProtection)]"
		>
			<div class="panel-list-item special">
				<div
					class="fireprotection-icon"
					:class="[getType(fireProtection.inventoryType), { mobile: isMobile }]"
					@click="openInstruction(fireProtection)"
				></div>
			</div>
			<p class="panel-list-item pos" :class="{ mobile: isMobile }">
				{{ fireProtection.positionNumber }}
			</p>
			<div class="panel-list-item" v-if="!isMobile">
				{{ displayFPName(fireProtection) }}
			</div>

			<div class="panel-list-item placement">
				{{ fireProtection.placementDescription }}
			</div>
			<div class="panel-list-item flaw-item" v-if="!isMobile">
				{{ getFlaw(fireProtection) }}
			</div>
			<div class="button-container" v-if="!isMobile">
				<div class="instruction-icon">
					<i class="far fa-question-circle" />
					<span class="instruction-tooltip" v-if="fireProtection.instruction">
						{{ tInstruction(fireProtection.instruction) }}
					</span>
				</div>
				<div class="field has-addons">
					<div class="control">
						<button
							class="button is-success"
							:disabled="disableOk(fireProtection)"
							@click="noFlaw(fireProtection)"
						>
							Ok
						</button>
					</div>
					<div class="control">
						<button class="button" @click="addFlaw(index)">
							{{ $t('protectionslist.flaw') }}
						</button>
					</div>
				</div>
			</div>
			<div class="mobile-buttons" v-else>
				<button
					class="button is-success"
					:disabled="disableOk(fireProtection)"
					@click="noFlaw(fireProtection)"
				>
					{{ $t('protectionslist.ok_button') }}
				</button>
				<button class="button" @click="addFlaw(index)">{{ $t('protectionslist.flaw') }}</button>
			</div>
		</div>
		<div class="title-container flaw-title">
			<div class="title">{{ $t('protectionslist.loose_flaws_title') }}</div>
			<button
				class="button is-info"
				:class="{ mobile: isMobile }"
				@click="addFlaw(-1)"
			>
				<span class="icon"><i class="fas fa-plus"/></span>
				<span>{{ $t('protectionslist.new_flaw_button') }}</span>
			</button>
		</div>
		<div></div>
		<div class="panel-list-header" :class="{ mobile: isMobile }">
			<div class="panel-filler-icon" />
			<div class="panel-header-item flaw-item">{{ $t('protectionslist.flaw') }}</div>
			<div class="panel-header-item flaw-item" v-if="!isMobile">
				{{ $t('protectionslist.description') }}
			</div>
			<div class="panel-filler-special" :class="{ mobile: isMobile }" />
		</div>
		<div
			class="panel-list no-hover flaw-list"
			v-for="(flaw, index) in flaws"
			:key="flaw.id"
			:class="[{ mobile: isMobile }, isDone(flaw)]"
		>
			<div class="panel-list-item special">
				<div class="fireprotection-icon flaw"></div>
			</div>
			<div class="panel-list-item flaw-item">
				{{ flaw.name }}
			</div>
			<div class="panel-list-item flaw-item" v-if="!isMobile">
				{{ flaw.description }}
			</div>
			<div class="button-container flaw">
				<div class="field has-addons">
					<div class="control">
						<button class="button" @click="addFlaw(index, 'flaw')">
							{{ $t('protectionslist.flaw') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="flaws.length == 0">
			<p class="panel-list-item">{{ $t('protectionslist.no_results') }}</p>
		</div>
		<InstructionModal
			v-if="showInstruction"
			:item="selectedItem"
			@close="closeInstruction"
		/>
	</div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';
import InstructionModal from './InstructionModal.vue';
import { mapGetters, mapMutations } from 'vuex';
export default {
	mixins: [iconMixin],
	components: {
		InstructionModal
	},
	props: {
		infos: Array
	},
	data: () => ({
		selectedInfo: {},
		selectedIndex: 0,
		selectedItem: {},
		showInstruction: false
	}),
	computed: {
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('roundStore', ['round']),
		...mapGetters('roundHistoryStore', ['activeRound']),
		items() {
			let items = [];

			if (this.selectedInfo) items = this.selectedInfo.roundHistoryItems;

			return items;
		},
		flaws() {
			let flaws = [];

			if (this.selectedInfo) flaws = this.selectedInfo.flaws;

			return flaws;
		}
	},
	methods: {
		...mapMutations('roundHistoryStore', ['SET_ACTIVEROUND']),
		selectLabel({ buildingName, floorName }) {
			return `${buildingName} - ${floorName}`;
		},
		selectInfo(info) {
			this.selectedIndex = this.infos.findIndex(
				element => element.id === info.id
			);
			this.selectedInfo = this.infos[this.selectedIndex];
			let roundData = { ...this.activeRound };
			roundData.currentInfo = this.selectedIndex;
			this.SET_ACTIVEROUND(roundData);
			this.$emit('update');
		},
		flawAdded(item) {
			const infoIndex = this.infos[
				this.selectedIndex
			].roundHistoryItems.findIndex(i => i.id === item.id);
			this.infos[this.selectedIndex].roundHistoryItems[infoIndex] = item;
			this.selectedInfo = this.infos[this.selectedIndex];
			this.$emit('saveState');
		},
		isDone(item) {
			const length = item.flaws ? item.flaws.length : 0;

			if (item.continueWithoutAdding)
				return 'ignored-not-done';

			if (item.controlled && length) {
				if (item.flawScale) {
					return item.created < this.round.created ? 'done' : 'not-done';
				}

				if (item.flaws.length) {
					return item.flaws[length - 1].created < this.round.created
						? 'done'
						: 'not-done';
				}
			}

			if (item.controlled) {
				return 'done';
			}
		},
		noFlaw(item) {
			let roundData = { ...this.activeRound };
			const infoIndex = this.infos[
				this.selectedIndex
			].roundHistoryItems.findIndex(i => i.id === item.id);
			item.controlled = new Date();
			item.userName = roundData.userName;
			this.infos[this.selectedIndex].roundHistoryItems[infoIndex] = item;
			this.$emit('saveState');
		},
		addFlaw(index, type) {
			if (type && type === 'flaw') {
				index = index + this.selectedInfo.roundHistoryItems.length;
			}

			this.$emit('addFlaw', index);
		},
		getFlaw(item) {
			const length = item.flaws ? item.flaws.length : 0;

			if (
				length &&
        (!item.flaws[length - 1].done ||
          item.flaws[length - 1].created > this.round.created ||
          !item.flaws[length - 1].created)
			) {
				const isDone = item.flaws[length - 1].done ? this.$t('protectionslist.fixed') + ' - ' : '';

				return isDone + item.flaws[length - 1].name;
			}

			return '';
		},
		disableOk(item) {
			const length = item.flaws ? item.flaws.length : 0;

			if (length && (!item.flaws[length - 1].done)) {
				return true;
			}

			return false;
		},
		openInstruction(item) {
			if (!this.isMobile) return;

			this.selectedItem = item;
			this.showInstruction = true;
		},
		closeInstruction() {
			this.showInstruction = false;
		}
	},
	created() {
		let roundData = { ...this.activeRound };
		this.selectedIndex = roundData.currentInfo;
		this.selectedInfo = this.infos[roundData.currentInfo];
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";
.title-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &.flaw-title {
    margin-top: 1rem;
    .button {
      margin-top: -0.5rem;
      &.mobile {
        margin-right: 0.5rem;
        margin-left: auto;
        margin-top: -0.2rem;
        margin-bottom: 0.5rem;
      }
    }
  }
}
.dash-select {
  margin-top: -0.5rem;
  &.mobile {
    margin-right: 0.5rem;
    margin-left: auto;
    margin-top: -0.5rem;
    margin-bottom: 0.5rem;
  }
}
.button {
  border-radius: 2px;
}
.panel-list-item.special {
  margin-right: 5px;
  max-width: 40px;
  position: relative;
}
.panel-list-item,
.panel-header-item {
  flex: 2;
  &.placement,
  &.flaw-item {
    flex: 3;
  }
}
.panel-list,
.panel-list-header {
  &.mobile {
    padding: 8px;
  }
}
.panel-list {
  &.done {
    background-color: #cdebcd !important;
    &:nth-child(odd) {
      background-color: #c3e0c3 !important;
    }
  }

  &.not-done {
    background-color: #f0cbcb !important;
    &:nth-child(odd) {
      background-color: #e9b9b9 !important;
    }
  }

  &.ignored-not-done {
	background-color: rgba(255, 123, 0, .4);

	&:nth-child(odd) {
		background-color: rgba(255, 123, 0, .25);
	}
  }

  &.flaw-list {
    padding-top: 1rem;
  }
}
.fireprotection-icon {
  background-color: transparent;
  top: -7px;
  width: 30px;
  height: 30px;
  z-index: 2;
  position: absolute;
  background-size: contain;
  &.mobile {
    transform: translateY(30px);
  }
}
.panel-filler-special {
  margin-right: 120px;
  &.mobile {
    margin-right: 65px;
  }
}
.mobile-buttons {
  max-width: 65px;
  margin-right: 0;
  .button {
    width: 65px;
  }
}
.panel-list-item.pos,
.panel-header-item.pos {
  max-width: 80px;
  &.mobile {
    max-width: 40px;
  }
}
.button-container {
  margin-top: -16px;
  position: relative;
  margin-right: 120px;
  &.flaw {
    margin-top: -20px;
    margin-right: 65px;
    margin-left: 55px;
  }
  .field {
    position: absolute;
    top: 8px;
  }
  .instruction-icon {
    position: absolute;
    display: flex;
    left: -2.5rem;
    top: 0.5rem;
    height: 100%;
    padding: 0 0.5rem;
    &:hover {
      i {
        color: $info-active;
      }
      .instruction-tooltip {
        visibility: visible;
      }
    }
    > i {
      margin: auto;
    }
    .instruction-tooltip {
      visibility: hidden;
      background: #f7f7f7;
      border: 1px solid grey;
      border-radius: 4px;
      min-width: 360px;
      position: absolute;
      padding: 5px;
      right: 105%;
      top: -5px;
      white-space: pre-wrap;
      box-shadow: 5px 5px 5px $shadow-color;
    }
  }
}
</style>

<style lang="scss">
.multiselect.panel-select.dashboard {
  min-width: 220px;
  max-width: 220px;
  .caret {
    background-color: #fcfcfc;
  }
  .multiselect__tags {
    background-color: white;

    .multiselect__single,
    .multiselect__input {
      background-color: white;
    }
  }
  .multiselect__content {
    background: white;
  }
}
</style>
